// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ujIi","notes":"Notes_notes__xkzZv"};